const INITIAL_STATE = {
  suggestions: [],
  loading: false,
  error: null,
}

interface SuggestionsState {
  suggestions: any[]
  loading: boolean
  error: string | null
}

export default function suggestionsReducer(
  state: SuggestionsState = INITIAL_STATE,
  action: any
) {
  switch (action.type) {
    case "SET_SUGGESTIONS":
      return {
        ...state,
        suggestions: action.payload,
        loading: false,
        error: null,
      }
    default:
      return state
  }
}
